module.exports = __webpack_public_path__ + "img/code1.8156e1ac.png";